import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class DataPermissionsService {
  // 获取角色列表
  static async getRoleList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Microi/get-role-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取用户列表
  static async getUserList(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Microi/get-user-list', payload))
    return Callback(err, res)
  }
  // 获取部门列表
  static async getDeptList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Microi/get-dept-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取授权规则列表
  static async getOperatorType(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/AuthorizationClass/get_operator_type?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取维度类型
  static async getDimensionType() {
    const [err, res] = await To(wizStandardInstance.get('/api/std/Microi/get_dimension_type'))
    return Callback(err, res)
  }
  // 获取审核状态
  static async getApproveStatus() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/AuthorizationClass/get_approve_status')
    )
    return Callback(err, res)
  }
  // 新增
  static async create(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/AuthorizationClass/batch-create', payload)
    )
    return Callback(err, res)
  }
  // 查询
  static async query(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/AuthorizationClass?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 权限回收
  static async setValid(payload) {
    const [err, res] = await To(
      wizStandardInstance.put('/api/std/AuthorizationClass/set-isvalid', payload)
    )
    return Callback(err, res)
  }
  // 详情页获取列表分页接口
  static async getClassAttributeAtributerule(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/AuthorizationClass/get-class-attribute-atributerule',
        payload
      )
    )
    return Callback(err, res)
  }
  // 获取权限变更记录
  static async getChangeLogs(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/AuthorizationClass/get-class-relation-rule-change-log',
        payload
      )
    )
    return Callback(err, res)
  }
}
